export const setBalances = (u, balances) => {
    u('balances', () => balances);
};
